import { render, staticRenderFns } from "./SearchSugg.vue?vue&type=template&id=2a69b8f6&scoped=true&"
import script from "./SearchSugg.vue?vue&type=script&lang=js&"
export * from "./SearchSugg.vue?vue&type=script&lang=js&"
import style0 from "./SearchSugg.vue?vue&type=style&index=0&id=2a69b8f6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a69b8f6",
  null
  
)

export default component.exports